import '@fontsource-variable/fraunces/index.css'
import './index.css'
import { bootstrap } from './bootstrap'
import { hasPendingCachePurge, registerServiceWorker, runPendingCachePurge } from './lib/serviceWorker'
import { hasAccountTransitionInProgress, listenForOwnerChanges, waitForAccountTransition } from './lib/accountChannel'
import { startOfflineRuntime } from './lib/offline/runtime'
import { createAppOfflineAdapter } from './lib/offline/appAdapter'
import { installDeckOutboxBridge } from './lib/offline/deckOutboxBridge'

const root = document.getElementById('root')!

// Offline data (contracts C1-C5, docs in mtg-api 2026-10-23-offline-contracts):
// C3 recovery runs first (a crashed sign-out is finished before any screen
// reads account data), then identity, connectivity and the sync scheduler.
// useAuth waits for it. VITE_OFFLINE_KILL=1 leaves it off (today's
// online-only behavior, every caller falls back).
if (import.meta.env.VITE_OFFLINE_KILL !== '1') {
  void startOfflineRuntime(createAppOfflineAdapter())
  installDeckOutboxBridge()
}

// Startup (translate guard, GA4, stores, interface language, then the first
// render) lives in bootstrap.ts so its order can be tested. A Cache Storage
// purge from an account transition that did not verify last time is retried
// FIRST, before anything can load account data (src/lib/serviceWorker.ts).
// With no tombstone (every normal load) bootstrap starts synchronously, as
// before. Likewise, while another tab is signing an account out, this tab
// waits (bounded) for the session to leave shared storage before it boots
// (src/lib/accountChannel.ts).
if (hasPendingCachePurge() || hasAccountTransitionInProgress()) {
  void waitForAccountTransition()
    .then(() => (hasPendingCachePurge() ? runPendingCachePurge() : null))
    .finally(() => bootstrap(root))
} else {
  void bootstrap(root)
}

// A peer tab's account transition: reload if this tab still shows the
// account that left (src/lib/accountChannel.ts).
listenForOwnerChanges()

// The offline service worker (sw/service-worker.js, built into dist/sw.js).
// Production only: dev has no dist/sw.js and must never run a cached build.
if (import.meta.env.PROD) registerServiceWorker()
